'use strict';

var ResourceFactory = require('../Factory');
var Validate = require('../../core').Validate;

var definition = {
  name: 'DataCapture',
  basePath: ':basePath',
  endpoint: 'data_captures',
  debug: false,
  methods: null,
  relations : {
    belongsTo : {
      Site : {
        localField : 'site',
        localKey: 'siteId'
      }
    }
  }
};


var DataCaptureResource = function(DS) {
  var resourceFactory = new ResourceFactory(DS);

  this.initialize = function (options) {
    var resourceOptions = getResourceOptions(options);
    return resourceFactory.createResource(resourceOptions);
  };
};

var getResourceOptions = function(options) {

  Validate.exists(options, 'fbBaseUri');
  Validate.exists(options, 'fbAuthToken');

  return {
    name : 'DataCapture',
    apiBaseUri: options.apiBaseUri,
    collectionMethods: {
      getGroupByDate : function(siteId, date) {
        // TODO
      },
      getDefaultByDate : function(date) {
        // TODO
      },

      findAll : function(params, options) {
        var DS = this.$DS;

        options = options || {};
        options.endpoint = 'sites/{{siteId}}/data_captures';

        return DS.findAll.call(DS, this.$name, params, options);
      }
    },
    modelMethods: {
      canRequestMeasurements: function() {
        var result = this.info3d &&
          this.info3d.uuid &&
          this.dataCaptureLayers &&
          this.dataCaptureLayers.some(function(layer) {
            return layer.layerType === 'pc_rgb';
          });
        return !!result; // Convert to boolean
      }
    },

    group : true,

    hooks : {
      afterInject : function(options, models) {
        // TODO
        // if(Array.isArray(models)) {
        //   var resource = options.getResource(options.name);
        //   resource.addOrCreateGrouping(models, 'date');
        // }
      }
    },

    // definition formatted and passed to js-data DS
    definition: {
      format: definition,
      params: {
        basePath: options.apiBaseUri,
        name : 'DataCapture'
      }
    },

    // sync trigger definitions
    // the model trigger definitions will be initiliazed and attached to every collection model
    syncTriggers: {
      // collection: [{
      //   type: 'firebase',
      //   basePath: options.fbBaseUri,
      //   endpoint: 'sites/:siteId/datacaptures/lastUpdated',
      //   token: options.fbAuthToken
      // }]
    }
  };
};

module.exports = DataCaptureResource;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/data/src/resources/dataCapture/DataCaptureResource.js